import React from "react";
import { Card, Form } from "react-bootstrap";

const TagSnippetCard = ({ tenantId, regionCode }) => {
  const snippet = `<script
  src="https://susan-consent-page.s3.eu-west-1.amazonaws.com/tag.js"
  data-tenant-id="${tenantId}"
  data-region="${regionCode}"
  async
></script>`;

  return (
    <Card className="mb-3">
      <Card.Header>
        <h5>DPDP Website Consent Tag</h5>
      </Card.Header>
      <Card.Body>
        <p>
          Add this script inside the <code>&lt;head&gt;</code> or just before{" "}
          <code>&lt;/body&gt;</code> on your website.
        </p>
        <Form.Control
          as="textarea"
          rows={4}
          value={snippet}
          readOnly
          onFocus={(e) => e.target.select()}
          style={{ fontFamily: "monospace" }}
        />
      </Card.Body>
    </Card>
  );
};

export default TagSnippetCard;
